import { ReviewType } from './types'

export const reviewTitle = (assetTitle: string, type: ReviewType) => {
  switch (type) {
    case ReviewType.APPROVAL:
      return `Approval: ${assetTitle}`
    case ReviewType.SUGGESTIONS:
      return `Suggestions: ${assetTitle}`
    case ReviewType.READ_RECEIPTS:
      return `Read Receipts: ${assetTitle}`
    default:
      return `Review: ${assetTitle}`
  }
}
